import { render, staticRenderFns } from "./CCModal.vue?vue&type=template&id=65d60348&scoped=true&"
import script from "./CCModal.vue?vue&type=script&lang=js&"
export * from "./CCModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d60348",
  null
  
)

export default component.exports